import * as deloitteCookies from 'js-cookie/src/js.cookie.js';
import * as Handlebars from 'handlebars/dist/handlebars.js';
import * as gfunctions from '../../../js/generalFunctions';

CCL.mainNav = {
  autoload: [
    ['mobileMenu', $('.header').length > 0],
    ['bindsailingContextClick', $('.sailing-context .sailing-id').length > 0],
    ['mNavSearch', $('.search .m-nav-search').length > 0],
    ['categoryOverlay', $('#dropdown-categories').length > 0],
    ['searchResult', $('.search-results').length > 0]

  ],
  timer: '',
  searchOptions: {
    minLength: 3,
    displayProductImages: true,
    delay: 1000,
    autocompleteUrl: ''
  },
  mobileMenu() {
    $('.menu-toggle').attr('aria-expanded', 'false');
    $('.menu-toggle').click(() => {
      $('.menu-toggle').attr('aria-expanded', 'true');
      $('body').toggleClass('menu-open');
    });
    $('.mobile-nav .close').click(() => {
      $('body').toggleClass('menu-open');
      $('.menu-toggle').focus().css('border', '2px solid #00b5cb');
      $('.menu-toggle').attr('aria-expanded', 'false');
    });
    $('.buy-mode .dropdown-menu').click((e) => {
      e.stopPropagation();
    });
    $('.categories .dropdown-toggle').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.search-mob').focus();
        });
      }
    });
    $('.search-mob').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.cart-mob a').focus();
        });
      }
      if ((event.keyCode === 9) && (event.shiftKey)) {
        $(() => {
          $('.categories .dropdown-toggle').focus();
        });
      }
    });
    $('.cart-mob a').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.my-cruise a').focus();
        });
      }
      if ((event.keyCode === 9) && (event.shiftKey)) {
        $(() => {
          $('.search-mob').focus();
        });
      }
    });
    $('.my-cruise a').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        $(() => {
          $('.cart-mob a').focus();
        });
      }
    });
  },
  bindsailingContextClick() {
    $('.sailing-context .sailing-id').each((index, element) => {
      if ($(element).hasClass('active')) {
        deloitteCookies.remove('SailingContextCookie');
        deloitteCookies.set('SailingContextCookie', $(element).data('code'));
      }
      $(element).on('click', (event) => {
        $('.sailing-context .sailing-id').removeClass('active');
        $(element).addClass('active');
        if (deloitteCookies.get('SailingContextCookie')) {
          deloitteCookies.remove('SailingContextCookie');
          deloitteCookies.set('SailingContextCookie', $(event.currentTarget).data('code'));
        } else {
          deloitteCookies.set('SailingContextCookie', $(event.currentTarget).data('code'));
        }
        window.location.reload(true);
      });
    });
  },
  mNavSearch() {
    $('.search .m-nav-search').focus(() => {
      $('.search').addClass('focused');
    });
    $('.search .m-nav-search').focusout(() => {
      $('.search').removeClass('focused');
    });
    $('body').on('click keypress', '.category-overlay', (e) => {
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
      $('body').find('.search-results').hide();
    });
  },

  searchResult() {
    const option = $('#searchTopHeader').data('options');
    if (option) {
      this.searchOptions.minLength = option.minCharactersBeforeRequest;
      this.searchOptions.displayProductImages = option.displayProductImages;
      this.searchOptions.delay = option.waitTimeBeforeRequest;
      this.searchOptions.autocompleteUrl = option.autocompleteUrl;
    }

    $('#dropdown-categories').on('click', (e) => {
      $('.search-results').hide();
      $('body').removeClass('add-category-overlay');
      $('body').find('.category-overlay').remove();
    });

    $('#searchTopHeader').on('keyup', (e) => {
      const searchTerm = $('#searchTopHeader').val();
      const keycode = (e.keyCode ? e.keyCode : e.which);
      if (searchTerm.length) {
        $('.search-clear-icon').show();
        if (keycode === 13) {
          this.formQuery();
        } else {
          this.triggerSearchCall();
        }
      } else {
        $('.search-clear-icon').hide();
        $('.search-results').hide();
        $('body').removeClass('add-category-overlay');
        $('body').find('.category-overlay').remove();
      }
    });

    $('.search-clear-icon').on('click keypress', (e) => {
      $('#searchTopHeader').val('');
      $('.search-clear-icon').hide();
      $('.search-results').hide();
      $('body').removeClass('add-category-overlay');
      $('body').find('.category-overlay').remove();

      $('#searchTopHeader').focus();
    });

    $('.mobile-search').hide();
    $('.search-mob').attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', '0');
    $('.search-mob').attr('aria-label', 'Search gifts and services');
    $('.search-mob a').attr('tabindex', '-1');
    $('.search-mob').on('click keypress', (e) => {
      if ($('.form-group.search').is(':visible')) {
        $('.search-mob').focus();
        $('.search-mob').attr('aria-expanded', 'false');
      } else {
        $('.m-nav-search').attr('aria-label', 'Search Text field. Type what you are looking for gifts and services');
        $('.search-mob').attr('aria-expanded', 'true');
      }
      $('.form-group').toggle();
      $('.m-nav-search').focus();
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
      $('body').find('.search-results').hide();
    });

    $('.search .search-link').on('click keypress', (e) => {
      const searchTerm = $('#searchTopHeader').val();
      if (searchTerm.length) {
        this.formQuery();
      }
    });

    $('body').on('click keypress', '.search-results .suggested-item', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#searchTopHeader').val(e.currentTarget.innerText);
        this.formQuery();
      }
    });
  },

  formQuery() {
    let search = $('#searchTopHeader').val();
    const patt = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i);
    if (!patt.test(search)) {
      search = encodeURIComponent(search.replace(/[/\\#+()$~%.,'":*?<>{}]/g, '').toLocaleLowerCase());
    }
    window.location = `/shop/search?text=${search}`;
  },

  triggerSearchCall() {
    const searchTerm = $('#searchTopHeader').val();
    clearTimeout(this.timer); // clear timer
    if (searchTerm.length >= this.searchOptions.minLength) {
      this.timer = setTimeout(this.triggerSearch, this.searchOptions.delay);
    }
  },

  triggerSearch() {
    let searchTermNew = $('#searchTopHeader').val();
    // Atleast on letter + atleast one number
    const patt = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i);
    if (!patt.test(searchTermNew)) {
      searchTermNew = encodeURIComponent(searchTermNew.replace(/[/\\#+()$~%.,'":*?<>{}]/g, '').toLocaleLowerCase());
    }
    const url = $('#searchTopHeader').data('options');
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/search/search-suggestion.json';
    } else {
      ajaxUrl = `${url.autocompleteUrl}?term=${searchTermNew}`;
    }
    $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: ajaxUrl,
      dataType: 'json'
    }).done((res) => {
      if (res.products.length || res.suggestions.length) {
        $('body').find('.category-overlay').remove();
        $('body').append('<div class="category-overlay"><div>');
        $('body').addClass('add-category-overlay');
        // Trigger ajax to get the HTML
        $.ajax({
          type: 'GET',
          url: '/_ui/responsive/ccl/assets/templates/search/search-suggestion.html'
        }).done((response) => {
          const templateScript = Handlebars.compile(response);
          const html = templateScript(res);
          $('.search-results').empty().append(html);
          $('.search-results').fadeIn('fast');
          let i = 0;
          while ($('.suggested-item').eq(i).html() !== undefined) {
            if ($('.suggested-item').eq(i).html().indexOf(searchTermNew) !== -1 && $('.suggested-item').eq(i).html().indexOf(searchTermNew) === 0) {
              const searchSubstr = $('.suggested-item').eq(i).html().substr(0, searchTermNew.length);
              const concatSubstr = $('.suggested-item').eq(i).html().substr(searchTermNew.length);
              $('.suggested-item').eq(i).html(`<b>${searchSubstr}</b>${concatSubstr}`);
            }
            i++;
          }
          CCL.mainNav.focusOrder();
        }).fail(() => {
          gfunctions.hideLoader();
          console.log('error Occured');
        });
      }
    }).fail(() => {
      console.log('error Occured in search');
    });
  },

  focusOrder() {
    const lastFocusItem = $('.product-suggestions .suggested-product-item').last();
    const lastFocus = lastFocusItem.find('.product-name a');
    // $('.search').on('keydown', (e) => {
    //   if ((e.keyCode === 9) && (e.shiftKey)) {
    //     e.preventDefault();
    //     $(lastFocus).focus();
    //   }
    // });
    $(lastFocus).on('keydown', (e) => {
      if ((e.keyCode === 9) && !(e.shiftKey)) {
        e.preventDefault();
        $('.search').addClass('focused');
        $('.search .form-control').focus();
      }
    });
  },

  categoryOverlay() {
    $('.categories.dropup').on('shown.bs.dropdown', () => {
      $('body').append('<div class="category-overlay"><div>');
      $('body').addClass('add-category-overlay');
    });
    $('.categories.dropup').on('hidden.bs.dropdown', () => {
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-main-nav/main-nav.js